<template lang="pug">
  div
    el-table(:data="data" :empty-text="emptyData")
      el-table-column(
        prop="chave"
        :label="colunaChave"
      )
      el-table-column(
        prop="quantidade"
        label="Quantidade"
      )
    el-row
      h4 Total: {{totalDeConversas}} conversas
</template>

<script>
export default {
  name: 'AppListagemConversas',
  props: {
    data: {
      type: Array,
      required: true
    },
    colunaChave: {
      type: String,
      required: false
    },
    totalDeConversas: {
      type: Number,
      required: false
    },
    emptyData: {
      type: String,
      required: false,
      default: 'Não há dados registrados no período informado'
    }
  }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/screens/relatorios_ouvidoria/components/AppListagemConversas.vue